const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M20.249 12a.75.75 0 0 0-.065-.306l-.123-.19-.032-.035L12.78 4.22a.751.751 0 1 0-1.062 1.062l5.967 5.967H4.75a.751.751 0 0 0 0 1.502h12.933l-5.966 5.967a.751.751 0 0 0 1.062 1.062l7.249-7.249.002-.002a.75.75 0 0 0 .218-.529"/></svg>';
export {
  a as w
};
